'use client'

import React, { ReactNode } from 'react'

import Link from 'next/link'
import clsx from 'clsx'

type TBreadCrumbProps = {
    pathNames: string[],
}

const NextBreadcrumb = ({pathNames}: TBreadCrumbProps) => {
    const newpathname = pathNames.map(v=> v.replaceAll('_', '-'))
    return (
        <div className='container bread'>
            <ul className={'flex items-center mb-2'}>
                <li className={'p-2 text-[0.67rem] text-slate-700 font-normal'}>
                    <Link href={'/'}>Home</Link>
                </li>
                {newpathname.length > 0 && <span className='text-[0.67rem] text-slate-700 font-thin'>&gt;</span>}
                {newpathname.map((link, index) => {
                    let href = `/${newpathname.slice(0, index + 1).join('/')}`;
                    const isLastIndex = index === newpathname.length - 1;
                    return (
                        <React.Fragment key={index}>
                            <li className={`${isLastIndex ? 'activeUrl !text-slate-700 !font-bold pointer-events-none text-ellipsis overflow-hidden' : ''} px-2 text-[0.67rem] text-slate-700 font-normal text-nowrap`}>
                                {isLastIndex ? (
                                    <span>{link.replaceAll('-', ' ')}</span>
                                ) : (
                                    <a href={href.toLowerCase()}>{link.replaceAll('-', ' ')}</a>
                                )}
                            </li>
                            {!isLastIndex && <span className='text-[0.67rem] text-slate-700 font-thin'>&gt;</span>}
                        </React.Fragment>
                    );
                })}
            </ul>
        </div>
    );
    
}

export default NextBreadcrumb
